import { render, staticRenderFns } from "./processKrasNonRiskbook.vue?vue&type=template&id=a9449324"
import script from "./processKrasNonRiskbook.vue?vue&type=script&lang=js"
export * from "./processKrasNonRiskbook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a9449324')) {
      api.createRecord('a9449324', component.options)
    } else {
      api.reload('a9449324', component.options)
    }
    module.hot.accept("./processKrasNonRiskbook.vue?vue&type=template&id=a9449324", function () {
      api.rerender('a9449324', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/dashboard/processRam/processKrasNonRiskbook.vue"
export default component.exports